// extracted by mini-css-extract-plugin
export default {"prompt":"prompt--rAC8M","promptIcon":"promptIcon--UANP9","promptMenu":"promptMenu--bes6Z","promptTextArea":"promptTextArea--Oq2bX","activeIcon":"activeIcon--oKyjY"};